module.exports = __webpack_public_path__ + "static/media/02_arduino.46352ebc.png";